import script from "./UserOverviewStatistics.vue?vue&type=script&setup=true&lang=js"
export * from "./UserOverviewStatistics.vue?vue&type=script&setup=true&lang=js"

import "./UserOverviewStatistics.vue?vue&type=style&index=0&id=0e0ae910&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e0ae910"]])

export default __exports__